var render = function render(){var _vm=this,_c=_vm._self._c;return _c('news',{attrs:{"news":_vm.news,"layout":"Wide"}})
}
var staticRenderFns = []

export { render, staticRenderFns }